import { motion, useReducedMotion } from "framer-motion";
export function SignalBridge() {
  const shouldReduceMotion = useReducedMotion();
  return <div className="bg-gradient-hero flex w-full items-center justify-center px-5 py-7 md:py-9" aria-hidden="true" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-749" data-mp="1ihz802e5j3rg">
      <div className="mx-auto mt-14 flex w-full justify-center md:mt-16" data-id="element-750" data-mp="1s7adzg5qrsb4">
        <svg viewBox="0 0 360 64" className="h-auto w-[92%] max-w-[360px] overflow-visible" fill="none" role="img" aria-label="H.E.R." data-id="element-751" data-mp="1x5u3trngho8r">
          {/* Línea izquierda */}
          <motion.path d="M8 32 H112" stroke="#C8A870" strokeWidth="1.2" strokeLinecap="round" initial={{
          pathLength: shouldReduceMotion ? 1 : 0,
          opacity: shouldReduceMotion ? 0.75 : 0
        }} whileInView={{
          pathLength: 1,
          opacity: 0.75
        }} viewport={{
          once: true,
          amount: 0.7
        }} transition={{
          pathLength: {
            duration: shouldReduceMotion ? 0 : 0.7,
            ease: [0.22, 1, 0.36, 1]
          },
          opacity: {
            duration: shouldReduceMotion ? 0 : 0.3
          }
        }} data-id="element-752" data-mp="2233t97auhzwl" />

          {/* Línea derecha */}
          <motion.path d="M248 32 H352" stroke="#C8A870" strokeWidth="1.2" strokeLinecap="round" initial={{
          pathLength: shouldReduceMotion ? 1 : 0,
          opacity: shouldReduceMotion ? 0.75 : 0
        }} whileInView={{
          pathLength: 1,
          opacity: 0.75
        }} viewport={{
          once: true,
          amount: 0.7
        }} transition={{
          pathLength: {
            duration: shouldReduceMotion ? 0 : 0.7,
            ease: [0.22, 1, 0.36, 1],
            delay: shouldReduceMotion ? 0 : 0.15
          },
          opacity: {
            duration: shouldReduceMotion ? 0 : 0.3,
            delay: shouldReduceMotion ? 0 : 0.15
          }
        }} data-id="element-753" data-mp="3t1p3qa8z37lh" />

          {/* Logo central */}
          <motion.text x="180" y="40" textAnchor="middle" fill="#C8A870" className="font-display" style={{
          fontSize: "30px",
          fontWeight: 500,
          letterSpacing: "0.18em"
        }} initial={{
          opacity: shouldReduceMotion ? 1 : 0,
          y: shouldReduceMotion ? 0 : 5
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.7
        }} transition={{
          duration: shouldReduceMotion ? 0 : 0.7,
          delay: shouldReduceMotion ? 0 : 0.25,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-754" data-mp="2vdnl85ztenej">
            H · E · R
          </motion.text>
        </svg>
      </div>
    </div>;
}